<script>
    export default {
        props: {
            columns: Array,
            data: Array
        }
    }
</script>

<template>
    <div class = "t">
        <img src="https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/grid-swipe-icon.png" alt="Swipe left or right to view columns" class="swipe-icon hide-lg">
        <div class="tr header">
            <div v-for="column in columns" :key="column.dataField" :class="['td', { disabled: column.disabled, sticky: column.sticky }]">
                <span>{{ column.header }}</span>
                <i v-if="column.subHeader">{{ column.subHeader }}</i>
            </div>
        </div>
        <div v-for="(item, index) in data" :key="index" class="tr">
            <div v-for="column in columns" :key="column.dataField + '_' + index" :class="['td', {sticky: column.sticky, disabled: column.disabled, glow:!column.disabled && (column.dataField == 'ibCost' || column.dataField == 'mmbCost') && (index == 0 || index == 1)}]">
                <div v-if="!column.disabled && (column.dataField == 'ibCost' || column.dataField == 'mmbCost') && (index == 0 || index == 1)" class="savings-ribbon" id="savings-ribbon">
                   BEST VALUE
                </div>
                <span v-if="column.strikeDataField && item[column.strikeDataField]" class="strike-box">
                    <span class="strike" v-html="item[column.strikeDataField]"></span>
                </span>
                <span v-if="item[column.dataField]" :class="{ bold: !!column.strikeDataField && item[column.strikeDataField]}"
                      v-html="item[column.dataField]"></span>
                <span v-if="column.subDataField && item[column.subDataField]" class="sub" v-html="item[column.subDataField]">

                </span>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    /* the "table" (everything is flex) -- still needs mobile styling. */
    .glow:not(.disabled) {
        background-color: #efdeb1 !important;
        /* color: aqua !important;*/
    }
    .savings-ribbon:not(.ibe-display-none) {
        color: #2a3e30;
        font-family: Montserrat;
        font-size: 8px;
        font-weight: 700;
        font-style: normal;
        letter-spacing: normal;
        line-height: normal;
        text-align: left;
        background-color: #e5af22;
        position: absolute;
        top: 0;
        left: 0px;
        width: 65px;
        clip-path: polygon(0% 0%, 100% 0%, 85% 50%, 100% 100%, 0% 100%);
        -webkit-clip-path: polygon(0% 0%, 100% 0%, 85% 50%, 100% 100%, 0% 100%);
    }
    .savings-ribbon:not(.ibe-display-none) {
        margin-top: 0;
        margin-left: 0;
    }
    .t {
        position: relative;
        display: flex;
        flex-direction: column;

        .swipe-icon {
            position: sticky;
            position: -webkit-sticky;
            position: -moz-sticky;
            position: -ms-sticky;
            position: -o-sticky;
            height: 29px;
            width: 45px;
            left: 23px;
            top: 37px;
            z-index: 2;
        }
        
        .tr {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: flex-end;
            min-height: 52px;
            
            .td {
                position:relative;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 141px;
                height: 52px;
                padding: 0 10px;
                text-align: center;
                color: #3b4e55;
                
                * {
                    max-width: 100%;
                }
                
                &:first-of-type {
                    padding-left: 23px;
                    padding-right: 0;
                    width: 163px;
                    font-size: 14px;
                    color: #ffffff;
                    font-weight: 400;
                    background-color: inherit;
                    align-items: flex-start;
                }

                &:not(:first-of-type) {
                    margin-right: 5px;
                }
                
                &.disabled {
                    width: 138px;
                    color: #4c4c4c;
                    background-color: #dbdbdb;
                    border-left: 2px solid #4c4c4c;
                    border-right: 2px solid #4c4c4c;
                    
                    i {
                        display: block;
                        font-size: 10px;
                        line-height: 15px;
                    }
                }

                .bold {
                    font-weight: 600;
                }
                
                /* Extra container is necessary to draw red strikethrough on black text (IE11 doesn't support text-decoration-color) */
                .strike-box {
                    text-decoration: line-through;
                    color: red;
                    margin-right: 7px;
                    font-size: 14px;
                    padding-top: 1px;
                    
                    .strike {
                        color: #3b4e55;
                    }
                }
                
                .sub {
                    font-size: 11px;
                    font-weight: 400;
                    line-height: 14px;
                }
            }

            &.header {
                font-size: 12px;
                color: #4c4c4c;
                font-weight: 400;
                line-height: 15px;
                
                .td:not(.disabled):not(:first-of-type) {
                    background-color: #f7f7f7;
                }
                
                i {
                    height: 0;
                }
            }
            
            &:nth-of-type(2) {
                background-color: #006643;
             /*   .td{
                       &:nth-of-type(2){
                                         background-color: #efdeb1 !important;   
                                       }
                        &:nth-of-type(3) {
                            background-color: #efdeb1 !important;   
                        }
                        
                   }*/
            }
            
            &:nth-of-type(3) {
                background-color: #0c6d4c;
            }
            
            &:nth-of-type(4) {
                background-color: #247a5d;
            }
            
            &:nth-of-type(5) {
                background-color: #308165;
                /* border creates the appearance of the last row extending down beyond the columns*/
                border-bottom: 5px solid #308165;
            }
            
            &:not(.header) {
                &:nth-of-type(odd) {
                    .td:not(.disabled):not(:first-of-type) {
                        background-color: #f7f7f7;
                    }
                }
                
                &:nth-of-type(even) {
                    .td:not(.disabled):not(:first-of-type) {
                        background-color: #ececec;
                    }
                }
            }
            
            &:first-of-type {
                height: 63px;

                .td {
                    height: 61px;
                    
                    &.disabled {
                        height: 78px;
                    }

                    &:first-of-type {
                        background-color: #006643;/* Not transparent */
                        /* border should match the spacing between gradient and grid rows*/
                        border-bottom: 5px solid white;
                    }
                }
                
                .disabled {
                    border-top: 2px solid #4c4c4c
                }
            }
            
            &:not(:first-of-type) {
                .td:not(:first-of-type) {
                    flex-direction: row;
                }
            }
            
            &:last-of-type {
                .disabled {
                    border-bottom: 2px solid #4c4c4c
                }
            }
        }
    }

    @media @tablet-lg {
        .t {
            min-width: 991px;
            
            .tr {
                min-height: 52px;
                
                .td {
                    min-width: 115px;
                    height: 52px;
                    flex-grow: 1;
                    
                    *{
                        max-width: 100%;
                    }
                    
                    &:first-of-type {
                        padding-left: 14px;
                        padding-right: 0;
                        max-width: 103px;
                        font-size: 11px;
                        position: sticky;
                        position: -webkit-sticky;
                        position: -moz-sticky;
                        position: -ms-sticky;
                        position: -o-sticky;
                        left: 0;
                        z-index: 1;
                    }

                    &:not(:first-of-type) {
                        margin-right: 3px;
                        font-size: 14px;
                    }

                    &.disabled {
                        min-width: 103px;
                        border-left: 2px solid #4c4c4c;
                        border-right: 2px solid #4c4c4c;
                        
                        i {
                            font-size: 8px;
                        }
                    }

                    &.sticky {
                        position: sticky;
                        position: -webkit-sticky;
                        position: -moz-sticky;
                        position: -ms-sticky;
                        position: -o-sticky;
                        left: 115px;
                        z-index: 1;
                        box-shadow: 3px 0 4px -2px;
                    }
                    
                    .bold {
                        font-weight: 600;
                    }
                    
                    /* Extra container is necessary to draw red strikethrough on black text (IE11 doesn't support text-decoration-color) */
                    .strike-box {
                        text-decoration: line-through;
                        color: red;
                        margin-right: 7px;
                        font-size: 14px;
                        padding-top: 1px;
                        
                        .strike {
                            color: #3b4e55;
                        }
                    }
                    
                    .sub {
                        font-size: 8px;
                    }
                    
                }

                &.header {
                    font-weight: 400;
                    line-height: 15px;
                    
                    span {
                        font-size: 10px;
                    }

                    .td:not(.disabled):not(:first-of-type) {
                        background-color: #f7f7f7;
                    }
                    
                    i {
                        height: 0;
                    }
                }
                
                &:nth-of-type(2) {
                    background-color: #006643;
                }
                
                &:nth-of-type(3) {
                    background-color: #0c6d4c;
                }
                
                &:nth-of-type(4) {
                    background-color: #247a5d;
                }
                
                &:nth-of-type(5) {
                    background-color: #308165;
                    /* border creates the appearance of the last row extending down beyond the columns*/
                    border-bottom: 5px solid #308165;
                }
                
                &:not(.header) {
                    &:nth-of-type(odd) {
                        .td:not(.disabled):not(:first-of-type) {
                            background-color: #f7f7f7;
                        }
                    }
                    
                    &:nth-of-type(even) {
                        .td:not(.disabled):not(:first-of-type) {
                            background-color: #ececec;
                        }
                    }
                }
                
                &:first-of-type {
                    height: 63px;

                    .td {
                        height: 61px;
                        
                        &:first-of-type {
                            background-color: #006643;/* Not transparent */
                            /* border should match the spacing between gradient and grid rows*/
                            border-bottom: 5px solid white;
                        }
                    }
                    
                    .disabled {
                        border-top: 2px solid #4c4c4c
                    }
                }
                
                &:not(:first-of-type) {
                    .td:not(:first-of-type) {
                        flex-direction: row;
                    }
                }
                
                &:last-of-type {
                    .disabled {
                        border-bottom: 2px solid #4c4c4c
                    }
                }
            }
        }
    }

    @media @tablet {
        .t {
            min-width: 811px;
            .tr {
                &.header {
                    line-height: 13px;

                    .td {
                        border-top-left-radius: 2px;
                        border-top-right-radius: 2px;
                        padding: 0 5px;
                    }
                }

                &:last-of-type {
                    .td {
                        border-bottom-left-radius: 2px;
                        border-bottom-right-radius: 2px;
                    }
                }

                .td {
                    width: 114px;
                    min-width: 114px;
                    border-radius

                    &:first-of-type {
                        width: 103px;
                    }

                    &.sticky {
                        left: 109px;
                    }
                }
            }
        }
    }
</style>